import { render } from "./Technologies.vue?vue&type=template&id=71d8c980&scoped=true"
import script from "./Technologies.vue?vue&type=script&lang=js"
export * from "./Technologies.vue?vue&type=script&lang=js"

import "./Technologies.vue?vue&type=style&index=0&id=71d8c980&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71d8c980"]])

export default __exports__